require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./basic-styles-sandbox-preview-retirement-page.json") })
        }
      }, "path---basic-styles-sandbox-preview-retirement-page");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---basic-styles-sandbox-preview-retirement-page!./.cache/json/basic-styles-sandbox-preview-retirement-page.json
// module id = 1939
// module chunks = 231608221292675